import { IResourceComponentsProps, useShow, useTranslate } from '@pankod/refine-core';
import {
  Show,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
} from '@pankod/refine-antd';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { Ownership } from 'interfaces';

export const OwnershipShow: React.FC<IResourceComponentsProps> = () => {

  const { queryResult } = useShow<Ownership>();
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { data, isLoading } = queryResult;
  const record = data?.data;
  const t = useTranslate();

  return (
    <Show isLoading={isLoading}>
      <Form form={form} initialValues={record}
        name="time_related_controls"
        layout="vertical">
        <Form.Item hidden name="table">
          {' '}
          <Input type="hidden" />{' '}
        </Form.Item>
        <Row>
          <Col className="gutter-row" span={4}>
            <Form.Item name="active" valuePropName="checked" noStyle>
              <Checkbox disabled>{t('fields.active', {ns: 'ownerships'})}</Checkbox>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={4}>
            <Form.Item name="persistent" valuePropName="checked" noStyle>
              <Checkbox disabled>{t('fields.persistent', {ns: 'ownerships'})}</Checkbox>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={16}>
            <Form.Item
              label={t('fields.title', {ns: 'ownerships'})}
              name="title"
            >
              <Input disabled/>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={24}>
            <Form.Item
              label={t('fields.description', {ns: 'ownerships'})}
              name="description"
            >
              <TextArea disabled/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Show>
  );
};
